<template lang="pug">
.app-card-coupon-item(v-if="info")
  .left
    img(:src="info.pic | https")
    .mid
      .title {{ info.title }}
      .price(:class="{ 'with-assets': info.assets }")
        .current
          span.amount {{ info.currentPrice }}
          span.unit 元
        .origin {{ info.originPrice }}元
      .assets {{ info.assets }}
  .right.flex-mid
    .btn.flex-mid(@click="$emit('btn', info)") 购买
</template>

<script>
export default {
  filters: {
    https(v) {
      if (!v) {
        return v;
      }
      if (v.startsWith('http://')) {
        return v.replace('http', 'https');
      }
      return v;
    },
  },
  props: {
    info: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.app-card-coupon-item {
  display: flex;
  justify-content: space-between;

  .right {
    padding-left: 0.1rem;

    .btn {
      width: 0.6rem;
      height: 0.25rem;
      background: #e3f0ff;
      border-radius: 0.13rem;
      font-size: 0.12rem;
      font-weight: 500;
      color: #08f;
    }
  }

  .left {
    display: flex;

    img {
      width: 0.75rem;
      height: 0.45rem;
      margin-right: 0.12rem;
      border-radius: 0.04rem;
    }

    .mid {
      display: flex;
      flex-direction: column;
      max-width: 1.6rem;

      .assets {
        font-size: 0.12rem;
        color: #879099;
        line-height: 1;
        margin-top: 0.03rem;
      }

      .title {
        font-size: 0.14rem;
        font-weight: 600;
        color: #242729;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .price {
        display: flex;
        align-items: flex-end;
        margin-top: 0.12rem;

        &.with-assets {
          margin-top: 0.04rem;
        }

        .origin {
          font-size: 0.12rem;
          color: #879099;
          text-decoration: line-through;
          margin-left: 0.04rem;
        }

        .amount {
          font-size: 0.24rem;
          font-family: "DIN Alternate Bold", sans-serif;
          font-weight: bold;
          color: #ff5526;
          line-height: 1;
        }

        .unit {
          font-size: 0.12rem;
          font-weight: 500;
          color: #ff5526;
          line-height: 1;
        }
      }
    }
  }
}
</style>
